import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { LEVELS } from '../constants'
import { AlphabeticalMenu } from './MenuComponents/AlphabeticalMenu'
import { ListMenu } from './MenuComponents/ListMenu/ListMenu'

export const FourthLevel = () => {
  const { state } = useMenu()
  const { updatedMenu } = useGlobalNavigation()

  const mustRenderItems =
    typeof state.firstLevelItem?.index === 'number' &&
    typeof state.secondLevelItem?.index === 'number' &&
    typeof state.thirdLevelItem?.index === 'number' &&
    updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
      state.secondLevelItem.index
    ]?.nextLevel?.items[state.thirdLevelItem.index]?.nextLevel !== undefined

  const isAlphabetical =
    typeof state.firstLevelItem?.index === 'number' &&
    typeof state.secondLevelItem?.index === 'number' &&
    typeof state.thirdLevelItem?.index === 'number' &&
    updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
      state.secondLevelItem.index
    ]?.nextLevel?.items[state.thirdLevelItem.index]?.nextLevel?.alphabeticalMenu

  return (
    <div className="navigation-panel-step active">
      {mustRenderItems &&
        (isAlphabetical ? (
          <AlphabeticalMenu
            menu={
              updatedMenu[state.firstLevelItem.index!]?.nextLevel?.items[
                state.secondLevelItem.index!
              ]?.nextLevel?.items[state.thirdLevelItem.index!]?.nextLevel!
            }
          />
        ) : (
          <ListMenu
            menu={
              updatedMenu[state.firstLevelItem.index!]?.nextLevel?.items[
                state.secondLevelItem.index!
              ]?.nextLevel?.items[state.thirdLevelItem.index!]?.nextLevel!
            }
            type={LEVELS.fourth_level.toString()}
          />
        ))}
    </div>
  )
}
